var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31483 3.54942L4.31238 5.40684V14.5972C4.31238 16.1676 5.58545 17.4407 7.15586 17.4407L14.6944 17.4409C14.4241 18.2053 13.695 18.753 12.8379 18.753H7.15586C4.86064 18.753 3 16.8924 3 14.5972V5.40684C3 4.5488 3.54896 3.81897 4.31483 3.54942ZM15.0301 1.25098C16.1173 1.25098 16.9987 2.13233 16.9987 3.21954V14.5935C16.9987 15.6807 16.1173 16.5621 15.0301 16.5621H7.15586C6.06865 16.5621 5.1873 15.6807 5.1873 14.5935V3.21954C5.1873 2.13233 6.06865 1.25098 7.15586 1.25098H15.0301ZM15.0301 2.56335H7.15586C6.79346 2.56335 6.49967 2.85714 6.49967 3.21954V14.5935C6.49967 14.9559 6.79346 15.2497 7.15586 15.2497H15.0301C15.3925 15.2497 15.6863 14.9559 15.6863 14.5935V3.21954C15.6863 2.85714 15.3925 2.56335 15.0301 2.56335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c70502fa19dfbe0b4706ad1827b00f5a.svg";
export { ForwardRef as ReactComponent };